"use strict";

module.exports = {
  captureAsyncFunc: function captureAsyncFunc(arg, cb) {
    cb({
      addAnnotation: function addAnnotation() {},
      addMetadata: function addMetadata() {},
      addError: function addError() {},
      close: function close() {}
    });
  },
  captureAWS: function captureAWS(arg) {
    return arg;
  }
};